import SEO from '../components/SEO';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import API from '../services/api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      // Always show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <SEO title="Forgot Password" path="/forgot-password" noIndex={true} />
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-purple-700 transition-colors mb-6">
          <ArrowLeft size={15} /> Back to Sign In
        </Link>

        <div className="card shadow-sm border border-gray-100">
          {sent ? (
            <div className="text-center py-6">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                <CheckCircle size={32} className="text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 font-heading mb-2">Check Your Email</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                If an account exists for <strong>{email}</strong>, we have sent a password reset link.
                Please check your inbox and spam folder.
              </p>
              <p className="text-sm text-gray-400">Didn't receive it?{' '}
                <button onClick={() => setSent(false)} className="text-purple-600 hover:underline font-medium">
                  Try again
                </button>
              </p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <Link to="/login" className="btn-primary w-full block text-center">Back to Sign In</Link>
              </div>
            </div>
          ) : (
            <>
              <div className="mb-6">
                <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center mb-4">
                  <Mail size={22} className="text-purple-700" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900 font-heading">Forgot Password?</h1>
                <p className="text-gray-500 text-sm mt-2">
                  No worries! Enter your email address and we'll send you a link to reset your password.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label">Email Address</label>
                  <input
                    type="email"
                    className="input-field"
                    required
                    placeholder="you@example.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2">
                  {loading && <div className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />}
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <p className="text-center text-sm text-gray-500 mt-4">
                Remember your password?{' '}
                <Link to="/login" className="text-purple-700 font-semibold hover:underline">Sign in</Link>
              </p>
            </>
          )}
        </div>
    </div>
    </div>
  );
}
